import { Check, ChevronDown } from 'lucide-react'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/dropdown-menu/dropdown-menu'

import { UserRole } from '@/lib/queries/business/types'
import { cn } from '@/lib/utils'
import { capitalizeFirstLetter } from '@/lib/utils/string'

interface Props {
  role: UserRole
  readOnly: boolean
  disabled: boolean
  onRoleChange: (role: UserRole) => void
}

export const PermissionMenu: React.FC<Props> = ({ role, readOnly = false, disabled = false, onRoleChange }) => {
  if (readOnly || disabled) {
    return <div className={cn(disabled && 'text-muted-foreground')}>{capitalizeFirstLetter(role)}</div>
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-3">
        {capitalizeFirstLetter(role)}
        <ChevronDown size={14} />
      </DropdownMenuTrigger>

      <DropdownMenuContent>
        {Object.values(UserRole)
          .filter((role) => role !== UserRole.SUPER_ADMIN)
          .map((roleOption) => {
            const isChecked = roleOption === role

            return (
              <DropdownMenuItem key={roleOption} disabled={isChecked} onClick={() => onRoleChange(roleOption)}>
                <MenuItem roleOption={roleOption} checked={isChecked} />
              </DropdownMenuItem>
            )
          })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

interface MenuItemProps {
  roleOption: UserRole
  checked: boolean
}

const MenuItem: React.FC<MenuItemProps> = ({ roleOption, checked }) => {
  return (
    <div className="flex items-center gap-2">
      <Check className={cn(!checked && 'invisible')} size={15} />
      <span className="text-xs font-medium">{capitalizeFirstLetter(roleOption)}</span>
    </div>
  )
}
